String.prototype.toSwe = function() {
    const encodingFixMap = {
        "|": "ö",
        "\\": "Ö",
        "#": "Ö",
        "{": "ä",
        "[": "Ä",
        "}": "å",
        "]": "Å"
    };

    return this
        .split("")
        .map(char => encodingFixMap[char] || char)
        .join("")
        .replace(/\s+$/, ""); // Trim trailing whitespace
};

Date.prototype.toYYMMDD = function(){
    const yy = String(this.getFullYear()).slice(-2);
    const mm = String(this.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const dd = String(this.getDate()).padStart(2, '0');
    return yy + mm + dd;
}

Date.prototype.getCurrentTime = function(){
    return this.getHours().toString().padStart(2, '0') + this.getMinutes().toString().padStart(2, '0');
}

Number.prototype.getWeekday = function(){
    const num = this%6
    switch(num){
        case 0:
            return 'Söndag'
        case 1:
            return 'Måndag';
        case 2:
            return 'Tisdag'
        case 3:
            return 'Onsdag';
        case 4:
            return 'Torsdag';
        case 5:
            return 'Fredag';
        case 6:
            return 'Lördag'
        default:
            return 'Måndag'
    }
}
